export const EXTERNAL_LINK_DISCLAIMER_VERSION = 'external-link-v1';

export const EVENT_PAGE_INDEPENDENCE_TITLE = 'Independent event discovery and delegate support';

export const EVENT_PAGE_INDEPENDENCE_STATEMENT =
  'Jigsaw Events Hub helps delegates discover and research events. Unless expressly stated, Jigsaw Conferences Ltd is not the event organiser, ticket seller, sponsor, partner or representative. Event information may change, so please verify the organiser, dates, venue and destination website before booking, paying or travelling.';

export const EVENT_PAGE_INDEPENDENCE_SECONDARY =
  'A listing or external link does not, by itself, indicate affiliation, authorisation or endorsement.';

export const EVENT_WEBSITE_VERIFICATION_MESSAGE = 'Event website verification in progress';
export const EVENT_WEBSITE_UNAVAILABLE_MESSAGE = 'This event website is currently unavailable. Please check again later or contact our team if you need assistance.';

export const isSafeExternalEventUrl = (value) => {
  if (!value || typeof value !== 'string') return false;
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
};

export const getNormalizedHostname = (value) => {
  if (!isSafeExternalEventUrl(value)) return '';
  const parsed = new URL(value);
  return parsed.hostname.replace(/^www\./i, '').toLowerCase();
};

export const getEventWebsiteControl = (event) => {
  const review = event?.eventWebsiteReview || {};
  const rawUrl = review.destinationUrl || event?.officialUrl || event?.organiserWebsite || '';
  const safeUrl = isSafeExternalEventUrl(rawUrl) ? rawUrl : '';
  const publicStatus = review.publicStatus || review.status || (safeUrl ? 'legacy' : 'removed');

  if (publicStatus === 'unverified') {
    return {
      status: 'unverified',
      url: '',
      hostname: getNormalizedHostname(rawUrl),
      publicClickable: false,
      message: EVENT_WEBSITE_VERIFICATION_MESSAGE,
    };
  }

  if (publicStatus === 'disputed' || publicStatus === 'removed') {
    return {
      status: publicStatus,
      url: '',
      hostname: getNormalizedHostname(rawUrl),
      publicClickable: false,
      message: EVENT_WEBSITE_UNAVAILABLE_MESSAGE,
    };
  }

  if (!safeUrl) {
    return {
      status: publicStatus,
      url: '',
      hostname: '',
      publicClickable: false,
      message: EVENT_WEBSITE_UNAVAILABLE_MESSAGE,
    };
  }

  return {
    status: publicStatus,
    url: safeUrl,
    hostname: getNormalizedHostname(safeUrl),
    publicClickable: true,
    message: '',
  };
};